import state from './modulePrestacaoContaState'
import mutations from './modulePrestacaoContaMutations'
import actions from './modulePrestacaoContaActions'
import getters from './modulePrestacaoContaGetters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
